import * as firebase from "firebase/app";
import { signupViaSNS } from '@/api/sns-user'
import user_util from '@/utils/UserUtils'

export function fbLoginWithPopUp(additional_data) {
    return new Promise((resolve, reject) => {
        const provider = new firebase.auth.FacebookAuthProvider();

        firebase.auth().signInWithPopup(provider).then( (result) => {

            if(result.additionalUserInfo){
                let pd_meta = result.additionalUserInfo;
            
                if(pd_meta.isNewUser){
                    // Save New user Data 
                    // pd_meta.profile
                    newRegister(result, additional_data)
                        .then(res => {
                            resolve(res)
                        })
                        .catch(err => {
                            firebase.auth().onAuthStateChanged(user => {
                                if (!user) reject(err.response);
    
                                user.delete().then(result => {
                                    reject(err.response);
                                }).catch(error => {
                                    reject(error)
                                });
                            })                            
                        })
                }else{
                    resolve(result);
                }
            }else{
                resolve(result);
            }
        }).catch( (error) => {
            reject(error);
        });
    })
}



/**
 * Register new user Data to DB
 * @param {*} googleUser
 */
export function newRegister(result, additional_data) {
    return new Promise((resolve, reject) => {

        let pd_meta = result.additionalUserInfo;
        let bDay = (pd_meta.profile.birthday)? user_util.getDate(pd_meta.profile.birthday) : '',
            params = {
                email: pd_meta.profile.email,
                birthday: (bDay)? `${bDay.year}/${bDay.month}/${bDay.day}`: null,
                gender: pd_meta.profile.gender,
                user_family_name: pd_meta.profile.last_name,
                user_first_name: pd_meta.profile.first_name,
                language_id: parseInt(additional_data.language_id), 
                sns_registration: 'true',
                user_nickname: pd_meta.profile.name,
                snsId: pd_meta.profile.id,
                firebase_uid: result.user.uid, // Firebase UID
                accessToken: result.credential.accessToken
            }

        signupViaSNS(params).then((data) => {
            resolve(data)
        }).catch(error => {
            reject(error.response)
        })
    })
}





/**
 * ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩
 *   ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩ Un necessary Part ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩
 * ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩
 */

export function fbLoginRedirectResult() {

    return new Promise((resolve, reject) => {
        firebase.auth().getRedirectResult().then((result) => {
            if(result.additionalUserInfo){
                let pd_meta = result.additionalUserInfo;
            
                if(pd_meta.isNewUser){
                    // Save New user Data 
                    // pd_meta.profile
                    newRegister(result)
                        .then(res => {
                            console.log(res)
                            resolve(res)
                        })
                        .catch(err => {
                            console.log(err)
                            firebase.auth().onAuthStateChanged(user => {
                                if (!user) reject(err.response);

                                user.delete().then(result => {
                                    reject(err.response);
                                    // console.log(result);
                                }).catch(error => {
                                    console.log(error);
                                });
                            })                            
                        })
                }else{
                    resolve(result);
                }
            }else{
                resolve(result);
            }
        }).catch((error) => {
            reject(error);
        });

    })
}



// WEBPACK FOOTER //
// ./src/auth/facebook.js